import React from "react";
import Grid from "@mui/material/Grid2";
import ProblemDetails from "./ProblemDetails";
import useDebugInformation from "../../../../../../hooks/useDebugInformation";

const name = "StepOneForm"

type Props = {
  parent: string
}

const StepOneForm: React.FC<Props> = ({ parent }) => {
  const debugName = `${parent}▷[${name}]`
  useDebugInformation(debugName, { parent })
  return (
    <>
      <Grid container >
        <form noValidate>
          <ProblemDetails parent={debugName} />
        </form>
      </Grid>
    </>
  );
}

export default React.memo(StepOneForm)
